import { render } from "./ImageLink.vue?vue&type=template&id=67c20ee2&scoped=true"
import script from "./ImageLink.vue?vue&type=script&lang=js"
export * from "./ImageLink.vue?vue&type=script&lang=js"

import "./ImageLink.vue?vue&type=style&index=0&id=67c20ee2&scoped=true&lang=css"

import exportComponent from "/Users/longpp/Desktop/klubcoin/universal-link/landing-page/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67c20ee2"]])

export default __exports__